import { styled } from '@mui/material';

import { PaginatorSize } from './types';
import { IconButton, IconButtonProps, iconButtonVars } from '../../../buttons';
import { tokens } from '../../../../theme/generated/tokens';

type PaginatorIconButtonProps = Omit<IconButtonProps, 'size' | 'variant'> & {
  size: PaginatorSize;
};

export const PaginatorIconButton = styled(
  ({ children, ...rest }: PaginatorIconButtonProps) => {
    return (
      <IconButton {...rest} size="sm" variant="ghost">
        {children}
      </IconButton>
    );
  }
)(({ size }) => [
  {
    ...iconButtonVars.setValues({
      color: tokens.theme.fg.action.onGhost,
      colorActive: tokens.theme.fg.action.onGhost,
      colorDisabled: tokens.theme.disabled.fg,
      background: 'unset',
      backgroundHover: tokens.theme.bg.action.ghostHover,
      backgroundActive: tokens.theme.bg.action.ghostActive,
      backgroundDisabled: 'unset',
      spinnerColor: tokens.theme.fg.action.onGhost,
      spinnerBorderColor: tokens.theme.disabled.fg,
    }),
  },
  size === 'md' && {
    ...iconButtonVars.setValues({
      iconSize: '20px',
    }),
    minHeight: '28px',
    minWidth: '28px',
  },
  size === 'sm' && {
    ...iconButtonVars.setValues({
      iconSize: '16px',
    }),
    minHeight: '24px',
    minWidth: '24px',
  },
]) as typeof IconButton;
